import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';
import type { WeatherDetailsViewProps } from '../schema';
import {
    weatherAssetDegreesCelsius,
    weatherAssetDegreesFahrenheit,
} from '../weather.locstring.json';
import loc from 'owa-localize';
import { WeatherIcon } from 'owa-weather-icons';

export default observer(function WeatherDetailsView({
    temp,
    skyCode,
    skyText,
    tempUnit,
}: WeatherDetailsViewProps) {
    const degreesString =
        tempUnit === WeatherTemperatureUnit.Celsius
            ? weatherAssetDegreesCelsius
            : weatherAssetDegreesFahrenheit;

    return (
        <div className={styles.weatherIcon}>
            <WeatherIcon
                skyCode={skyCode}
                skyText={skyText}
                style={styles.weatherSkyCodeIconFigure}
            />
            <div className={styles.temp}>{loc(degreesString, temp)}</div>
            <div>{skyText}</div>
        </div>
    );
});
